<script setup>
import {defineProps} from "vue";
import {useRouter} from "vue-router";
import {getReturnPath} from "@/Helper";

const router = useRouter();
const props = defineProps({
    path: Object
});

function goToPath(event) {
    event.preventDefault();

    const returnPath = getReturnPath();

    if (returnPath) {
        window.location.href = returnPath;
    } else {
        router.push({name: 'dashboard'});
    }
}
</script>
<template>
    <div class=" mb-4">
        <div class="">
            <a class="mb-4 flex items-center" href="#" @click="goToPath">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor" class="w-6 h-6 rtl:transform rtl:rotate-180">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"/>
                </svg>
                <span class="text-sm font-medium ltr:ml-3 rtl:mr-3">{{ $tt('path_page__back_button') }}</span></a>
        </div>
        <div class="relative h-80 overflow-hidden flex items-center justify-center rounded-xl">
            <img :src="props.path.image" :title="props.path.name" class="object-cover absolute"/>
            <div class="absolute top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center">
                <p class="text-3xl text-white font-medium">{{ props.path.name }}</p>
            </div>
        </div>
    </div>
</template>
